<template>
  <div class="news-section">
    <!-- 焦点新闻 -->
    <div class="news-block">
      <div class="section-header">
        <p  class="section-title" :class="{'section-title-select': focusTitSelectId == tit.id}"
        v-for="(tit, index) in focusTit" :key="index"
          @click="selectTab(tit.id)"
        >
        {{ tit.title }}
      </p>
        <a  class="more-link" @click="goNavMore(focusTitSelectId)">MORE+</a>
      </div>
      <div class="news-list">
        <!-- 左侧轮播图区域 -->
        <div class="news-main">
          <div class="swiper news-swiper" ref="newsSwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(news, index) in focusNews.slice(0, 3)" :key="index">
                <div class="main-image">
                  <img :src="news.image || require('@/assets/img/home-swiper-t1.jpg')" :alt="news.title" />
                  <div class="image-overlay">
                    <h3 class="main-title">{{ news.title }}</h3>
          </div>
                </div>
              </div>
            </div>
            <!-- 分页器 -->
            <div class="swiper-pagination"></div>
            <!-- 导航按钮 -->
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
          </div>
        </div>
        
        <!-- 右侧新闻列表 -->
        <div class="news-sidebar">
         
          <div class="news-item" v-for="(news, index) in focusNews.slice(0,6)" :key="index" @click="goDetail(news)">
            <span class="news-bullet"></span>
            <span class="news-text">{{ news.title }}</span>
            <span class="news-date">{{ news.date }}</span>
          </div>
         
        </div>
      </div>
    </div>

    <!-- 通知公告 -->
    <div class="notice-block">
      <div class="section-header">
        <p class="section-title">通知公告</p>
        <a @click="goNavMore(12)" class="more-link">MORE+</a>
      </div>
      <div class="notice-list">
        <div class="notice-item" v-for="(notice, index) in notices.slice(0,4)" :key="index"  @click="goDetail(notice)">
          <div class="notice-date-block">
            <div class="date-day">{{ notice.day }}</div>
            <div class="date-year-month">{{ notice.yearMonth }}</div>
          </div>
          <div class="notice-title">{{ notice.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import { homeApi,subApi } from '@/api/index'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export default {
  name: 'NewsSection',
  data() {
    return {
      // eslint-disable-next-line no-unused-vars
      swiper: null, // Swiper实例
      focusTit:[],
      focusTitSelectId: 1,
      newsData: {},
      notices: []
    }
  },
  computed: {
    focusNews() {
      console.log('focusNews',this.newsData[this.focusTitSelectId])
      return this.newsData[this.focusTitSelectId] || [];
    }
  },
  mounted() {
    this.initSwiper();
    this.getNoticeList();
    this.getArticleList();
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  },
  methods: {
    selectTab(tabId) {
      this.focusTitSelectId = tabId;
      // 切换 tab 时重新初始化轮播图
      this.$nextTick(() => {
        this.initSwiper();
      });
    },
    initSwiper() {
      // 销毁已存在的Swiper实例
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      
      this.$nextTick(() => {
        console.log('初始化Swiper...');
        console.log('newsSwiper ref:', this.$refs.newsSwiper);
        
        const paginationEl = this.$refs.newsSwiper.querySelector('.swiper-pagination');
        const nextEl = this.$refs.newsSwiper.querySelector('.swiper-button-next');
        const prevEl = this.$refs.newsSwiper.querySelector('.swiper-button-prev');
      
        // 创建新的Swiper实例
        this.swiper = new Swiper(this.$refs.newsSwiper, {
          modules: [Navigation, Pagination, Autoplay],
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: paginationEl,
            clickable: true
          },
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
          on: {
            init: () => {
              console.log('Swiper初始化完成');
            }
          }
        });
        
        console.log('Swiper实例:', this.swiper);
      });
    },
    // 获取Swiper实例的方法
    getSwiperInstance() {
      return this.swiper;
    },
    // 检查Swiper是否已初始化
    isSwiperReady() {
      return this.swiper !== null;
    },

    //获取公告列表数据
    
    async getNoticeList(){
    
      try {
        let params = {
          categoryId:12,
          count:4
        }
        
        const response = await subApi.getNavList(params)
      
        if (response && response.code === 0) {
         
          let data = response.data.subList;
           data.forEach(sub =>{
             sub.items.forEach(items=>{
               // 截取日期：假设datetime格式为 "2024-01-15" 或 "2024-01-15 10:30:00"
               const dateStr = items.datetime;
               let yearMonth = '';
               let day = '';
               
               if (dateStr) {
                 // 提取日期部分（去掉时间部分）
                 const dateOnly = dateStr.split(' ')[0];
                 const dateParts = dateOnly.split('-');
                 
                 if (dateParts.length >= 3) {
                   // 年月：2024-01
                   yearMonth = `${dateParts[0]}-${dateParts[1]}`;
                   // 日：15
                   day = dateParts[2];
                 }
               }
           
                this.notices.push({
                  title:items.title,
                  yearMonth: yearMonth,
                  day: day,
                  id:items.id
                
                })
             })
            })
          
         
        } else {
          
          // 设置默认数据
         this.secondList = [];
        }
      } catch (error) {
        
        // 设置默认数据
       this.secondList = [];
      } finally {
        // 隐藏加载状态
        this.loading = false;
      }
    },

       //获取焦点新闻等文章列表数据
    async getArticleList(){
      try {
        let params = {
          categoryIds:'2601,6,5,4',
          count:7
        }
        
        const response = await homeApi.getArticleList(params)
      
        if (response && response.code === 0) {
          
          let data = response.data;
          console.log('-----------------------',data)
          this.focusTitSelectId = data[0].id;
          console.log(this.focusTitSelectId,'focusTitSelectId')
          data.forEach(list => {
            console.log(list.id)
            this.focusTit.push({
              title:list.title,
              id:list.id
            })
            
            this.newsData[list.id] = []
            list.subList.forEach(sub =>{
             sub.items.forEach(items=>{
           
             
                this.newsData[list.id].push({
                  title:items.title,
                  date:items.datetime,
                  image:items.image,
                  id:items.id
                })
             })
            })
          });

          
        } else {
         
          this.newsData = [];
        }
      } catch (error) {
       // console.error('获取轮播图数据异常:', error)
      }
    },
    goNavMore(id){
      this.$router.push({
        path:'/category',
        query:{
          id:id
        }
      })
    },
    goDetail(item){
   
      
      this.$router.push({
        path:'/article',
        query:{
          id:item.id
        }
      })
    }
  }
}
</script>

<style scoped>
.news-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-bottom: 30px;
}

.news-block{
  width:800px;
  .section-header{
    border-top:1px solid #f1c25f;
  }
  .section-title {
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 8px 16px;
    border-radius: 4px;
    margin-right: 10px;
    display: inline-block;
  }
  .section-title:hover {
    background: #f1c25f;
      color: #fff;
  }
  .section-title-select {
      background: #f1c25f;
      color: #fff;
  }
}
.notice-block{
  width: 320px;
  .section-header{
     border-top:1px solid #3591f9;
     .section-title{
       background: #3591f9;
       color: #fff;
     }

  }
}

.news-block,
.notice-block {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.section-header {
  /* background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%); */
  color: #333;
  display: flex;
  position: relative;
 
}

.section-title {
  font-size: 16px;
  margin-right: 6px;
  padding: 12px 16px;
  background: #eee;
  
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.more-link {
  color: #333;
  text-decoration: none;
  font-size:12px;
  padding: 12px 16px;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}

.more-link:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
}

/* 新闻列表布局 */
.news-list {
  display: flex;
  gap: 15px;
  padding: 15px;
}

/* 左侧大图区域 */
.news-main {
  flex: 1;
  
.news-swiper {
  width: 390px;
  height: 245px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

  .swiper-slide{
    width: 100%;
    height: 100%;
    
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  /* 分页器样式 */
  .news-swiper .swiper-pagination {
    position: absolute !important;
    bottom: 50px !important;
    left: 50% !important;
    transform: translateX(-50%) !important;
    z-index: 10 !important;
    display: block !important;
    width: auto !important;
    height: auto !important;
    background: none !important;
  }
  
  .news-swiper .swiper-pagination .swiper-pagination-bullet {
    background: rgba(255, 255, 255, 0.8) !important;
    opacity: 1 !important;
    width: 20px !important;
    height: 20px !important;
    border-radius: 50% !important;
    margin: 0 3px !important;
    font-size: 12px !important;
    line-height: 20px !important;
    text-align: center !important;
    color: #fff !important;
    font-weight: bold !important;
    display: inline-block !important;
    cursor: pointer !important;
  }
  
  .news-swiper .swiper-pagination .swiper-pagination-bullet-active {
    background: #f1c25f !important;
    color: #fff !important;
  }
  
  /* 导航按钮样式 */
  .news-swiper .swiper-button-next,
  .news-swiper .swiper-button-prev {
    position: absolute !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    color: #fff !important;
    background: rgba(0, 0, 0, 0.6) !important;
    width: 30px !important;
    height: 30px !important;
    border-radius: 50% !important;
    margin-top: 0 !important;
    transition: all 0.3s ease !important;
    z-index: 10 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    cursor: pointer !important;
    border: 2px solid rgba(255, 255, 255, 0.3) !important;
  }
  
  .news-swiper .swiper-button-next:hover,
  .news-swiper .swiper-button-prev:hover {
    background: rgba(0, 0, 0, 0.8) !important;
    transform: translateY(-50%) scale(1.1) !important;
    border-color: rgba(255, 255, 255, 0.6) !important;
  }
  
  .news-swiper .swiper-button-next::after,
  .news-swiper .swiper-button-prev::after {
    font-size: 16px !important;
    font-weight: bold !important;
    color: #fff !important;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5) !important;
  }
  
  .news-swiper .swiper-button-next {
    right: 15px !important;
  }
  
  .news-swiper .swiper-button-prev {
    left: 15px !important;
  }
}

.main-image {
  position: relative;
  width: 100%;
  height:100%;
  overflow: hidden;
  border-radius: 8px;
}

.main-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-overlay {
  width: 100%;
  
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba( 0, 0,  0, 0.7);
  padding:8px 20px;
 
}

.main-title {
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  line-height:20px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);

}

/* 右侧新闻列表 */
.news-sidebar {
  width: 360px;
  flex-shrink: 0;

 
}

.news-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 5px;
}

.news-item:hover {
  background-color: #f8f9fa;
  transform: translateX(3px);
}

.news-item:hover .news-text {
  color: #1e3c72;
}

.news-item:hover .news-bullet {
  color: #3591f9;
}

.news-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.news-bullet {
  color: #3591f9;
  margin-right: 8px;
  font-size: 14px;
  font-weight: bold;
  width: 8px;
  height: 8px;
  display: inline-block;
  background: #3591f9;
  border-radius: 2px;
  flex-shrink: 0;
}

.news-text {
  flex: 1;
  color: #333;
  font-size: 13px;
  line-height: 1.4;
  margin-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-date {
  color: #999;
  font-size: 11px;
  white-space: nowrap;
  flex-shrink: 0;
}

/* 通知公告样式 */
.notice-list {
  padding: 6px 20px;
}

.notice-item {
  display: flex;
  align-items: center;
  padding: 6px 0 ;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.notice-item:hover {
  background-color: #f8f9fa;
  transform: translateX(5px);
}

.notice-item:hover .notice-title {
  color: #1e3c72;
}

.notice-item:last-child {
  border-bottom: none;
}

/* 日期块样式 */
.notice-date-block {
  width: 60px;
  height: 50px;
  background: #f5f5f5;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.date-day {
  font-size: 18px;
  font-weight: bold;
  color: #1e3c72;
  line-height: 1;
  margin-bottom: 2px;
}

.date-year-month {
  font-size: 10px;
  color: #666;
  line-height: 1;
}

/* 标题样式 */
.notice-title {
  flex: 1;
  font-size: 14px;
  color: #1e3c72;
  margin: 0;
  line-height: 1.4;
  font-weight: 500;
  transition: color 0.3s ease;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .news-section {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .news-block {
    width: 100%;
  }
  
  .news-list {
    flex-direction: column;
    gap: 15px;
  }
  
  .news-sidebar {
    width: 100%;
  }
  
  .main-image {
    height: 200px;
  }
  
  .main-title {
    font-size: 16px;
  }
  
  .news-text {
    font-size: 13px;
  }
  
  .news-date {
    font-size: 11px;
  }
  
  .notice-list {
    padding: 15px;
  }
  
  .notice-date-block {
    width: 50px;
    height: 45px;
  }
  
  .date-day {
    font-size: 16px;
  }
  
  .date-year-month {
    font-size: 9px;
  }
  
  .notice-title {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .news-list {
    padding: 15px;
  }
  
  .main-image {
    height: 180px;
  }
  
  .image-overlay {
    padding: 15px;
  }
  
  .main-title {
    font-size: 14px;
  }
  
  .news-item {
    padding: 6px 0;
  }
  
  .news-text {
    font-size: 12px;
  }
  
  .news-date {
    font-size: 10px;
  }
  
  .notice-list {
    padding: 10px;
  }
  
  .notice-date-block {
    width: 45px;
    height: 40px;
    margin-right: 10px;
  }
  
  .date-day {
    font-size: 14px;
  }
  
  .date-year-month {
    font-size: 8px;
  }
  
  .notice-title {
    font-size: 12px;
  }
}

/* Swiper样式 */
.news-swiper {
  position: relative;
}

.news-swiper .swiper-pagination {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: block;
  width: auto;
  height: auto;
}

.news-swiper .swiper-pagination .swiper-pagination-bullet {
  background: #ffffff !important;
  opacity: 1 !important;
  width: 20px !important;
  height: 20px !important;
  border-radius: 50% !important;
  margin: 0 3px !important;
  font-size: 12px !important;
  line-height: 20px !important;
  text-align: center !important;
  color: #333 !important;
  font-weight: bold !important;
  display: inline-block !important;
  cursor: pointer !important;
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
}

.news-swiper .swiper-pagination .swiper-pagination-bullet:hover {
  background: #ffffff !important;
  transform: scale(1.1) !important;
  box-shadow: 0 2px 8px rgba(255, 255, 255, 0.5) !important;
}

.news-swiper .swiper-pagination .swiper-pagination-bullet-active {
  background: #2d1cb0 !important;
  color: #fff !important;
  transform: scale(1.2) !important;
  box-shadow: 0 4px 12px rgba(45, 28, 176, 0.6) !important;
}

.news-swiper .swiper-button-next,
.news-swiper .swiper-button-prev {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-top: 0;
  transition: all 0.3s ease;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.news-swiper .swiper-button-next:hover,
.news-swiper .swiper-button-prev:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: translateY(-50%) scale(1.1);
  border-color: rgba(255, 255, 255, 0.6);
}

.news-swiper .swiper-button-next::after,
.news-swiper .swiper-button-prev::after {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.news-swiper .swiper-button-next {
  right: 15px;
}

.news-swiper .swiper-button-prev {
  left: 15px;
}
</style>

<!-- 非scoped样式，确保覆盖Swiper默认样式 -->
<style>
.news-section .news-swiper .swiper-pagination-bullet {
  background: #ffffff !important;
  opacity: 1 !important;
  width: 10px !important;
  height: 10px !important;
  border-radius: 50% !important;
  margin: 0 3px !important;
  font-size: 12px !important;
  line-height: 20px !important;
  text-align: center !important;
  color: #333 !important;
  font-weight: bold !important;
  display: inline-block !important;
  cursor: pointer !important;

}

.news-section .news-swiper .swiper-pagination-bullet:hover {
  background: #ffffff !important;
  transform: scale(1.1) !important;
  box-shadow: 0 2px 8px rgba(255, 255, 255, 0.5) !important;
}

.news-section .news-swiper .swiper-pagination-bullet-active {
  background: #2d1cb0 !important;
  color: #fff !important;
  transform: scale(1.2) !important;
  box-shadow: 0 4px 12px rgba(45, 28, 176, 0.6) !important;
}

.news-section .news-swiper .swiper-pagination {
  position: absolute !important;
  bottom: 50px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  z-index: 10 !important;
  display: block !important;
  width: auto !important;
  height: auto !important;
}
</style>


